module.exports = __webpack_public_path__ + "media/images/alumni/logos-806f54ef917280e93e3f1e937da3a367.png";